/**
 * Renders a link to a club page with an icon and club name for the clubs navigation dropdown on desktop
 */
import React from "react";
import { Link } from "react-router-dom";

const ClubLink = ({ to, imgSrc, altText, clubName, handleLinkClick }) => (
  <div className="flex flex-col justify-center items-start">
    <Link
      to={to}
      className="block pl-2 flex flex-row justify-start items-center hover-slide w-[340px] leading-tight py-0.5 text-[1.15rem]"
      onClick={handleLinkClick}
    >
      <img src={imgSrc} alt={altText} className="w-6 h-6 inline-block mr-2" />
      
      {clubName}
      
    </Link>
  </div>
);

export default ClubLink;
